import React from "react";
import { Link, useLocation } from "react-router-dom";
import LogoLaunchPad from "./LogoLaunchPad";
import { Home, LucideLayers, Rocket } from "lucide-react";

const Header: React.FC = () => {
  const location = useLocation();

  const menus = [
    {
      name: "Home",
      icon: Home,
      path: "/launchpad/dashboard",
    },
    {
      name: "PSP",
      icon: LucideLayers,
      path: "/launchpad/psp",
    },
    {
      name: "Deployments",
      icon: Rocket,
      path: "/launchpad/deployments",
    },
  ];

  return (
    <header className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <LogoLaunchPad />
          <div className="text-xl font-semibold">LaunchPad</div>
        </div>

        <div className="flex items-center gap-4">
          {menus.map((menu) => {
            const isActive = location.pathname === menu.path;

            return (
              <Link
                key={menu.name}
                to={menu.path}
                className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-blue-100 text-blue-700 font-semibold"
                    : "hover:bg-blue-100 hover:text-blue-700"
                }`}
              >
                <menu.icon className="w-4 h-4" />
                <span>{menu.name}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </header>
  );
};

export default Header;
